import { z } from "zod";

export const postPushTokenSchema = z.object({
	token: z.string(),
	provider: z.enum(["expo"]),
});

export type PostPushTokenSchema = z.infer<typeof postPushTokenSchema>;
